/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Stamps_DescriptionInputs */

const en_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open more cake boxes to earn stamps from duplicate cakes.`)
};

const ar_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح المزيد من صناديق الكعك للحصول على طوابع من الكعكات المكررة.`)
};

const de_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne mehr Kuchenboxen, um Stempel durch doppelte Kuchen zu erhalten.`)
};

const es_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre más cajas de pasteles para obtener sellos de los pasteles duplicados.`)
};

const fr_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez plus de boîtes à gâteaux pour gagner des timbres grâce aux gâteaux en double.`)
};

const it_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri più scatole di torte per ottenere timbri dalle torte doppie.`)
};

const ja_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキボックスをもっと開けて、重複したケーキからスタンプを獲得しましょう。`)
};

const ko_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이크 상자를 더 개봉하여 중복 케이크에서 스탬프를 획득해 보세요.`)
};

const pt_br_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra mais caixas de bolo para ganhar selos com bolos repetidos.`)
};

const ru_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открывайте больше коробок с тортом, чтобы получать штампы за повторяющиеся торты.`)
};

const th_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดกล่องเค้กเพิ่มเพื่อรับแสตมป์จากเค้กที่ซ้ำกัน`)
};

const tr_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yinelenen pastalardan pul kazanmak için daha fazla pasta kutusu açın.`)
};

const zh_cn_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从蛋糕礼盒中收集重复的蛋糕，就可以累积更多印花喔！`)
};

const zh_tw_dialog_not_enough_stamps_description = /** @type {(inputs: Dialog_Not_Enough_Stamps_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`從蛋糕禮盒中收集重複的蛋糕，就可以累積更多印花喔！`)
};

/**
* | output |
* | --- |
* | "Open more cake boxes to earn stamps from duplicate cakes." |
*
* @param {Dialog_Not_Enough_Stamps_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_stamps_description = /** @type {((inputs?: Dialog_Not_Enough_Stamps_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Stamps_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_stamps_description(inputs)
	if (locale === "ar") return ar_dialog_not_enough_stamps_description(inputs)
	if (locale === "de") return de_dialog_not_enough_stamps_description(inputs)
	if (locale === "es") return es_dialog_not_enough_stamps_description(inputs)
	if (locale === "fr") return fr_dialog_not_enough_stamps_description(inputs)
	if (locale === "it") return it_dialog_not_enough_stamps_description(inputs)
	if (locale === "ja") return ja_dialog_not_enough_stamps_description(inputs)
	if (locale === "ko") return ko_dialog_not_enough_stamps_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_stamps_description(inputs)
	if (locale === "ru") return ru_dialog_not_enough_stamps_description(inputs)
	if (locale === "th") return th_dialog_not_enough_stamps_description(inputs)
	if (locale === "tr") return tr_dialog_not_enough_stamps_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_stamps_description(inputs)
	return zh_tw_dialog_not_enough_stamps_description(inputs)
});